import React from 'react';
import { statusColors, statusLabels } from './utils';

interface ApplicationStatusBadgeProps {
  status: string;
}

export default function ApplicationStatusBadge({ status }: ApplicationStatusBadgeProps) {
  return (
    <span
      className={`px-2 py-1 text-xs font-medium rounded-full ${statusColors[status] || 'bg-gray-100 text-gray-700'}`}
    >
      {statusLabels[status] || status}
    </span>
  );
}
